// import { useEffect, useState, type JSX } from 'react';

// interface PlanetSignChange {
//   sign: string;
//   timestamp: string;
// }

// interface PlanetTransitResponse {
//   planetName: string;
//   sign: PlanetSignChange[];
// }

// const PAGE_SIZE = 10;

// const formatDateTime = (iso: string) =>
//   new Date(iso).toLocaleString('en-IN', {
//     day: '2-digit',
//     month: 'long',
//     year: 'numeric',
//     weekday: 'long',
//     hour: '2-digit',
//     minute: '2-digit',
//     hour12: true,
//   });

// export default function PlanetSignTable({
//   data,
//   selectedPlanet,
//   setSelectedPlanet,
// }: {
//   data: PlanetTransitResponse[];
//   selectedPlanet: string;
//   setSelectedPlanet: (v: string) => void;
// }): JSX.Element {
//   const [page, setPage] = useState(0);

//   useEffect(() => {
//     setPage(0);
//   }, [selectedPlanet]);

//   const active = data.find((p) => p.planetName === selectedPlanet) ?? data[0];

//   if (!active) {
//     return (
//       <section className="border border-[#2DAAFD] rounded-xl p-6">
//         <div className="text-center">No data available.</div>
//       </section>
//     );
//   }

//   const paginatedData = active.sign.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE);

//   const totalPages = Math.ceil(active.sign.length / PAGE_SIZE);

//   return (
//     <section className="border border-[#2DAAFD] rounded-xl p-6">
//       <h2 className="font-32 font-semibold font-spectral mb-8 bg-clip-text text-transparent bg-gradient-to-r from-[#082261] to-[#34065c] text-center">
//         Planet Changing of Sign (Grah Gochar)
//       </h2>

//       <div className="flex flex-col md:flex-row gap-6">
//         <aside className="md:w-[260px]">
//           <div className="border border-[#2DAAFD] rounded-xl p-2 space-y-2">
//             {data.map((p) => (
//               <button
//                 key={p.planetName}
//                 onClick={() => setSelectedPlanet(p.planetName)}
//                 className={`w-full px-4 py-2 rounded-[10px] font-spectral font-medium text-lg ${
//                   p.planetName === selectedPlanet
//                     ? 'bg-[linear-gradient(to_right,#082261,#34065c)] text-white'
//                     : 'inner-shadow-blue'
//                 }`}
//               >
//                 {p.planetName}
//               </button>
//             ))}
//           </div>
//         </aside>

//         <main className="flex-1">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             {paginatedData.map((item, i) => (
//               <div key={i} className="rounded-xl p-4 relative inner-shadow-blue">
//                 <div className="absolute -top-3 -left-3 bg-[linear-gradient(to_right,#082261,#34065c)] text-white w-7 h-7 rounded-full flex items-center justify-center">
//                   {page * PAGE_SIZE + i + 1}
//                 </div>

//                 <h4 className="font-20 font-lato font-medium bg-clip-text text-transparent bg-gradient-to-r from-[#082261] to-[#34065c]">
//                   {item.sign}
//                 </h4>

//                 <p className="font-16 font-lato">{formatDateTime(item.timestamp)}</p>
//               </div>
//             ))}
//           </div>

//           {active.sign.length > PAGE_SIZE && (
//             <div className="flex justify-center gap-4 mt-6">
//               <button
//                 disabled={page === 0}
//                 onClick={() => setPage((p) => p - 1)}
//                 className="px-5 py-2 border border-[#2DAAFD] rounded-lg disabled:opacity-50"
//               >
//                 Prev
//               </button>

//               <button
//                 disabled={page === totalPages - 1}
//                 onClick={() => setPage((p) => p + 1)}
//                 className="px-5 py-2 border border-[#2DAAFD] rounded-lg disabled:opacity-50"
//               >
//                 Next
//               </button>
//             </div>
//           )}
//         </main>
//       </div>
//     </section>
//   );
// }

import { useEffect, useState, type JSX } from 'react';

interface PlanetSignChange {
  sign: string;
  timestamp: string;
}

interface PlanetTransitResponse {
  planetName: string;
  sign: PlanetSignChange[];
}

const PAGE_SIZE = 10;

const formatDateTime = (iso: string) =>
  new Date(iso).toLocaleString('en-IN', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    weekday: 'long',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });

export default function PlanetSignTable({
  data,
  selectedPlanet,
  setSelectedPlanet,
}: {
  data: PlanetTransitResponse[];
  selectedPlanet: string;
  setSelectedPlanet: (v: string) => void;
}): JSX.Element {
  const [page, setPage] = useState(0);

  useEffect(() => {
    setPage(0);
  }, [selectedPlanet]);

 
  const active = data.find((p) => p.planetName === selectedPlanet);

  
  if (!active) {
    return (
      <section className="border border-[#2DAAFD] rounded-xl p-6 text-center">
        <p className="font-18 font-lato">No transit data available.</p>
      </section>
    );
  }


  if (active.sign.length === 0) {
    return (
      <section className="border border-[#2DAAFD] rounded-xl p-6">
        <h2 className="font-32 font-semibold font-spectral mb-10 bg-clip-text text-transparent bg-gradient-to-r from-[#082261] to-[#34065c] text-center">
          Planet Changing of Sign (Grah Gochar)
        </h2>

        <div className="flex flex-col md:flex-row gap-6">
          {/* LEFT SIDEBAR */}
          <aside className="md:w-[260px]">
            <div className="border border-[#2DAAFD] rounded-xl p-2 space-y-2">
              {data.map((p) => (
                <button
                  key={p.planetName}
                  onClick={() => setSelectedPlanet(p.planetName)}
                  className={`w-full px-4 py-2 rounded-[10px] font-spectral font-medium text-lg ${
                    p.planetName === selectedPlanet
                      ? 'bg-[linear-gradient(to_right,#082261,#34065c)] text-white'
                      : 'inner-shadow-blue'
                  }`}
                >
                  {p.planetName}
                </button>
              ))}
            </div>
          </aside>

         
          <main className="flex-1 flex items-center justify-center">
            <p className="font-18 font-lato text-[#082261] uppercase tracking-wide text-center">
              NO SIGN TRANSIT DATA AVAILABLE FOR{' '}
              <span className="font-semibold">{active.planetName}</span>.
            </p>
          </main>
        </div>
      </section>
    );
  }


  const paginatedData = active.sign.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE);

  const totalPages = Math.ceil(active.sign.length / PAGE_SIZE);

  return (
    <section className="border border-[#2DAAFD] rounded-xl p-6">
      <h2 className="font-32 font-semibold font-spectral mb-8 bg-clip-text text-transparent bg-gradient-to-r from-[#082261] to-[#34065c] text-center">
        Planet Changing of Sign (Grah Gochar)
      </h2>

      <div className="flex flex-col md:flex-row gap-6">
        <aside className="md:w-[260px]">
          <div className="border border-[#2DAAFD] rounded-xl p-2 space-y-2">
            {data.map((p) => (
              <button
                key={p.planetName}
                onClick={() => setSelectedPlanet(p.planetName)}
                className={`w-full px-4 py-2 rounded-[10px] font-spectral font-medium text-lg ${
                  p.planetName === selectedPlanet
                    ? 'bg-[linear-gradient(to_right,#082261,#34065c)] text-white'
                    : 'inner-shadow-blue'
                }`}
              >
                {p.planetName}
              </button>
            ))}
          </div>
        </aside>

        <main className="flex-1">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {paginatedData.map((item, i) => (
              <div key={i} className="rounded-xl p-4 relative inner-shadow-blue">
                <div className="absolute -top-3 -left-3 bg-[linear-gradient(to_right,#082261,#34065c)] text-white w-7 h-7 rounded-full flex items-center justify-center">
                  {page * PAGE_SIZE + i + 1}
                </div>

                <h4 className="font-20 font-lato font-medium bg-clip-text text-transparent bg-gradient-to-r from-[#082261] to-[#34065c]">
                  {item.sign}
                </h4>

                <p className="font-16 font-lato">{formatDateTime(item.timestamp)}</p>
              </div>
            ))}
          </div>

          {active.sign.length > PAGE_SIZE && (
            <div className="flex justify-center gap-4 mt-6">
              <button
                disabled={page === 0}
                onClick={() => setPage((p) => p - 1)}
                className="px-5 py-2 border border-[#2DAAFD] rounded-lg disabled:opacity-50"
              >
                Prev
              </button>

              <button
                disabled={page === totalPages - 1}
                onClick={() => setPage((p) => p + 1)}
                className="px-5 py-2 border border-[#2DAAFD] rounded-lg disabled:opacity-50"
              >
                Next
              </button>
            </div>
          )}
        </main>
      </div>
    </section>
  );
}
